<nav class="top-navigation">
  <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 pt-2">
    <div class="relative flex items-center justify-between h-16">

      <!-- Mobile Menu Icon -->
      <div
        (click)="showDropdown['mobileMenu']=!showDropdown['mobileMenu']"
        class="absolute inset-y-0 left-0 flex items-center md2:hidden">
        <!-- Mobile menu button-->
        <!-- class="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" aria-controls="mobile-menu" aria-expanded="false"> -->
        <button type="button"
          class="relative inline-flex items-center justify-center rounded-md p-2 text-green-800 hover:bg-green-800 hover:text-[#c4c0b0] focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" aria-controls="mobile-menu" aria-expanded="false">

          <span class="absolute -inset-0.5"></span>
          <span class="sr-only">Open main menu</span>
          <!--
          Icon when menu is closed. ("Hamburger Icon")

          Menu open: "hidden", Menu closed: "block"
          -->
          <svg
            [class.hidden]="showDropdown['mobileMenu']"
            class="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
          </svg>
          <!--
          Icon when menu is open. ("Large X Icon")

          Menu open: "block", Menu closed: "hidden"
          -->
          <svg
            [class.hidden]="!showDropdown['mobileMenu']"
            class="hidden h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Desktop Menu -->
      <div class="flex-1 flex items-center justify-center md2:items-stretch md2:justify-start">
        <div class="flex-shrink-0 lg:absolute lg:top-0 lg:left-[-8px]">
          <a routerLink="/home" class="text-green-800 font-bold text-xl">
            <img src="/assets/logo-menu-bar.svg" width="84" height="62"/>
          </a>
        </div>
        <div class="hidden md2:block md:ml-6 flex-grow relative left-16">
          <ul class="flex space-x-4 items-baseline">
            <li>
              <a
                routerLink="/home"
                routerLinkActive="border-green-800"
                ariaCurrentWhenActive="page"
                class="text-green-800 border-b-2 border-transparent hover:border-green-800 px-3 py-2 text-sm font-medium"
                >
                Home
              </a>
            </li>
            <li class="relative" (mouseenter)="showDropdown['teaTypes']=true" (mouseleave)="showDropdown['teaTypes']=false">
              <button
                [class.border-green-800]="showDropdown['teaTypes']"
                class="whitespace-nowrap inline text-green-800 border-b-2 border-transparent hover:border-green-800 px-3 py-2 text-sm font-medium"
                >
                Specialty Tea
              </button>
              @if (mainMenu$ | async; as mainMenu) {
                <div
                  [class.hidden]="!showDropdown['teaTypes']"
                  class="hidden absolute right-0 mt-0 w-48 rounded-md overflow-hidden z-20 wood-background drop-shadow">
                  @for (item of mainMenu['teaTypes']; track item) {
                    <a
                      [routerLink]="['/specialty-tea', item.slug]"
                      routerLinkActive="border-green-800 font-bold border-l-4"
                      ariaCurrentWhenActive="page"
                      class="block px-4 py-2 text-sm text-green-800 border-l-2 hover:border-green-800 hover:font-bold">{{ item.name }}
                    </a>
                  }
                </div>
              }
            </li>
            <!-- <li class="relative" (mouseenter)="showDropdown['teaRegions']=true" (mouseleave)="showDropdown['teaRegions']=false">
            <button
              [class.border-green-800]="showDropdown['teaRegions']"
              class="whitespace-nowrap inline text-green-800 border-b-2 border-transparent hover:border-green-800 px-3 py-2 text-sm font-medium"
              >
              Tea by Region
            </button>
            <div
              *ngIf="mainMenu$ | async as mainMenu"
              [class.hidden]="!showDropdown['teaRegions']"
              class="hidden absolute right-0 mt-0 w-48 rounded-md overflow-hidden z-20 wood-background drop-shadow">
              <a
                *ngFor = "let item of mainMenu['teaRegions']"
                [routerLink]="['/tea-region', item.slug]"
                routerLinkActive="border-green-800 font-bold border-l-4"
                ariaCurrentWhenActive="page"
                class="block px-4 py-2 text-sm text-green-800 border-l-2 hover:border-green-800 hover:font-bold">{{ item.name }}
              </a>
            </div>
          </li> -->
          <li class="relative" (mouseenter)="showDropdown['tisaneTypes']=true" (mouseleave)="showDropdown['tisaneTypes']=false">
            <button
              [class.border-green-800]="showDropdown['tisaneTypes']"
              class="whitespace-nowrap inline text-green-800 border-b-2 border-transparent hover:border-green-800 px-3 py-2 text-sm font-medium"
              >
              Herbal Tea
            </button>
            @if (mainMenu$ | async; as mainMenu) {
              <div
                [class.hidden]="!showDropdown['tisaneTypes']"
                class="hidden absolute right-0 mt-0 w-48 rounded-md overflow-hidden z-20 wood-background drop-shadow">
                @for (item of mainMenu['tisaneTypes']; track item) {
                  <a
                    [routerLink]="['/herbal-tea', item.slug]"
                    routerLinkActive="border-green-800 font-bold border-l-4"
                    ariaCurrentWhenActive="page"
                    class="block px-4 py-2 text-sm text-green-800 border-l-2 hover:border-green-800 hover:font-bold">{{ item.name }}
                  </a>
                }
              </div>
            }
          </li>
          <li class="relative" (mouseenter)="showDropdown['matchaTypes']=true" (mouseleave)="showDropdown['matchaTypes']=false">
            <button
              [class.border-green-800]="showDropdown['matchaTypes']"
              class="whitespace-nowrap inline text-green-800 border-b-2 border-transparent hover:border-green-800 px-3 py-2 text-sm font-medium"
              >
              Matcha
            </button>
            @if (mainMenu$ | async; as mainMenu) {
              <div
                [class.hidden]="!showDropdown['matchaTypes']"
                class="hidden absolute right-0 mt-0 w-48 rounded-md overflow-hidden z-20 wood-background drop-shadow">
                @for (item of mainMenu['matchaTypes']; track item) {
                  <a
                    [routerLink]="['/matcha-tea', item.slug]"
                    routerLinkActive="border-green-800 font-bold border-l-4"
                    ariaCurrentWhenActive="page"
                    class="block px-4 py-2 text-sm text-green-800 border-l-2 hover:border-green-800 hover:font-bold">{{ item.name }}
                  </a>
                }
              </div>
            }
          </li>
          <li class="relative" (mouseenter)="showDropdown['teaFlavours']=true" (mouseleave)="showDropdown['teaFlavours']=false">
            <button
              [class.border-green-800]="showDropdown['teaFlavours']"
              class="whitespace-nowrap inline text-green-800 border-b-2 border-transparent hover:border-green-800 px-3 py-2 text-sm font-medium"
              >
              Tea by Flavour
            </button>
            @if (mainMenu$ | async; as mainMenu) {
              <div
                [class.hidden]="!showDropdown['teaFlavours']"
                class="hidden absolute right-0 mt-0 w-48 rounded-md overflow-hidden z-20 wood-background drop-shadow">
                @for (item of mainMenu['teaFlavours']; track item) {
                  <a
                    [routerLink]="['/tea-flavour', item.slug]"
                    routerLinkActive="border-green-800 font-bold border-l-4"
                    ariaCurrentWhenActive="page"
                    class="block px-4 py-2 text-sm text-green-800 border-l-2 hover:border-green-800 hover:font-bold">{{ item.name }}
                  </a>
                }
              </div>
            }
          </li>
          <li class="relative" (mouseenter)="showDropdown['teaAccessories']=true" (mouseleave)="showDropdown['teaAccessories']=false">
            <button
              [class.border-green-800]="showDropdown['teaAccessories']"
              class="whitespace-nowrap inline text-green-800 border-b-2 border-transparent hover:border-green-800 px-3 py-2 text-sm font-medium"
              >
              Teawares <!-- Renamed from "Accessories" -->
              <!--
              Teawares:
              This term refers to a broad range of equipment used in the
              brewing and consumption of tea. It encompasses various
              components such as teapots, cups, bowls, trays, and other
              utensils. When you say “teawares,” you’re emphasizing the
              functional and practical aspects of the items used in tea preparation.
              Tea Wares: The term “tea wares” is more traditional and evokes
              a sense of cultural heritage. It specifically refers to tea
              sets, including tea pots, cups, and bowls. When you use
              “tea wares,” you’re emphasizing the artistry, craftsmanship,
              and cultural significance of these items
              -->
            </button>
            @if (mainMenu$ | async; as mainMenu) {
              <div
                [class.hidden]="!showDropdown['teaAccessories']"
                class="hidden absolute right-0 mt-0 w-48 rounded-md overflow-hidden z-20 wood-background drop-shadow">
                @for (item of mainMenu['teaAccessories']; track item) {
                  <a
                    [routerLink]="['/tea-wares', item.slug]"
                    routerLinkActive="border-green-800 font-bold border-l-4"
                    ariaCurrentWhenActive="page"
                    class="block px-4 py-2 text-sm text-green-800 border-l-2 hover:border-green-800 hover:font-bold">{{ item.name }}
                  </a>
                }
              </div>
            }
          </li>
          <!-- <li class="relative" (mouseenter)="showDropdown['giftTypes']=true" (mouseleave)="showDropdown['giftTypes']=false">
          <button
            [class.border-green-800]="showDropdown['giftTypes']"
            class="whitespace-nowrap inline text-green-800 border-b-2 border-transparent hover:border-green-800 px-3 py-2 text-sm font-medium"
            >
            Gifts
          </button>
          <div
            *ngIf="mainMenu$ | async as mainMenu"
            [class.hidden]="!showDropdown['giftTypes']"
            class="hidden absolute right-0 mt-0 w-48 rounded-md overflow-hidden z-20 wood-background drop-shadow">
            <a
              *ngFor = "let item of mainMenu['giftTypes']"
              [routerLink]="['/gifts', item.slug]"
              routerLinkActive="border-green-800 font-bold border-l-4"
              ariaCurrentWhenActive="page"
              class="block px-4 py-2 text-sm text-green-800 border-l-2 hover:border-green-800 hover:font-bold">{{ item.name }}
            </a>
          </div>
        </li> -->
      </ul>
    </div>
    <div class="md2:flex md2:flex-shrink-0 justify-end absolute md2:relative right-0">
      <a
        routerLink="/cart"
        routerLinkActive="lg:border-green-800"
        ariaCurrentWhenActive="page"
        class="text-green-800 border-b-2 border-transparent hover:border-green-800 px-3 py-2 text-sm font-medium relative">
        <!-- <img src="/assets/teapot-cart.svg" alt="cart" class="h-6 w-6 inline-block"> -->
        <!-- Start Teapot Icon -->
        <!-- <svg class="fill-[#95AB63] h-[24px] "  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 64" > -->
        <svg class="fill-green-800 h-[24px] "  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 64" >
          <path class="cls-1" d="m36.4,17.93s16.38.13,16.66-.11c.51-.44-.16-1.07-.5-1.38-.55-.5-1.01-1.51-1.24-2.19-.65-1.92-1.35-4.29-3.87-4.29-.14-.52-.63-.8-1.07-1.1-1.7-1.18-4.27-1.9-6-1.15-.45.19-.76.35-1.01.48.23-1.03,1.2-1.2,1.25-2.7C40.7,3.41,38.74,0,36.4,0c-2.35,0-4.3,3.41-4.23,5.48.05,1.51,1.02,1.67,1.25,2.7-.24-.13-.56-.29-1.01-.48-1.73-.75-4.29-.03-6,1.15-.44.3-.93.58-1.07,1.1-2.53,0-3.22,2.37-3.87,4.29-.23.69-.69,1.69-1.24,2.19-.34.31-1,.94-.5,1.38.29.25,16.66.11,16.66.11Z"/>
          <path class="cls-1" d="m63.83,19.88c-4.88-.29-9.03,4.48-10.11,4.45-.39-.01-.83-.24-1.52-.91.67-1.23,1.55-2,1.04-3.22H19.56c-.52,1.22.36,1.99,1.04,3.22-.22,3.65-3.12,8.19-4.93,11.59,0,0,0,0-.01,0-.71.36-1.98-.24-2.98-1.18-.74-.7-1.3-1.69-1.56-2.12-1.36-2.24-1.98-5.45-3.34-7.84-.43-.76-.95-1.48-1.64-2.18-.38-.39-.75-.65-1.02-.65-.11,0-3.82,1.38-4.87,1.76-.33.12-.33.19-.02.48.28.27.79.57,1.31.87,1.24.72,1.85,1.33,2.25,2.18.38.8.72,2.22.96,3.6.62,3.69.23,7.85,1,11.29.7,3.14,4.22,7.94,7.71,7.94.24.45.53.89.86,1.33,1.7,2.21,4.26,4.02,6.55,4.89-.26.87-.6,1.52-.6,2.47h32.24c0-.95-.34-1.59-.6-2.47,2.3-.87,4.85-2.67,6.56-4.89.31-.4.57-.81.8-1.22.33.29,1.29,0,1.79-.64.39-.49.79-1.17,1.21-1.86,3.31-5.52,10.02-8.21,11.12-14.77,1.02-6.15-3.33-11.74-9.57-12.12Zm1.38,20.1c-1.73,1.28-3.3,2.2-5.37,1.34h0c-.56-1.98-1.49-3.96-2.49-5.89-.58-1.12-1.31-2.39-2.04-3.72,2.25,0-.12-4.16,3.17-7.28,3.74-3.55,8.61-2.73,11.37,1.6,3.16,4.96-.31,10.74-4.65,13.96Z"/>
        </svg>
        @if ((cartItemCount$ | async) ?? 0 > 0) {
          <span class="top-4 -right-4 text-[9px] px-2 inline absolute lg:top-0 lg:right-0 inline-flex items-center justify-center lg:px-2 py-1 lg:text-[10px] font-bold leading-none text-red-100 bg-red-600 rounded-full">{{ (cartItemCount$ | async) ?? 0 }}</span>
        }
      </a>
    </div>
  </div>
</div>
</div>

<!-- Mobile Menu -->
<div [class.hidden]="!showDropdown['mobileMenu']" class="md2:hidden">
  <!-- <ul class="flex space-x-4 items-baseline"> -->
  <ul class="flex flex-col w-full text-center">
    <li class="w-full">
      <a
        routerLink="/home"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
        class="text-green-800 hover:bg-[#c4c0b0] px-3 py-2 rounded-md text-sm font-medium block w-full"
        >
        Home
      </a>
    </li>
    <li class="w-full" (click)="showDropdown['teaTypes']=!showDropdown['teaTypes']">
      <button class="block w-full text-green-800 hover:bg-[#c4c0b0] px-3 py-2 rounded-md text-sm font-medium">
        Specialty Tea
      </button>
      @if (mainMenu$ | async; as mainMenu) {
        <div
          [class.hidden]="!showDropdown['teaTypes']"
          class="hidden overflow-hidden wood-background border-l-2 border-green-800">
          @for (item of mainMenu['teaTypes']; track item) {
            <a
              [routerLink]="['/specialty-tea', item.slug]"
              routerLinkActive="bg-gray-700 text-white"
              ariaCurrentWhenActive="page"
              class="block px-4 py-2 text-sm text-green-800"
              (click)="closeDropdowns($event, 'teaTypes')">
              {{ item.name }}
            </a>
          }
        </div>
      }
    </li>
    <!-- <li class="w-full" (click)="showDropdown['teaRegions']=!showDropdown['teaRegions']">
    <button class="block w-full text-green-800 hover:bg-[#c4c0b0] px-3 py-2 rounded-md text-sm font-medium">
      Tea by Region
    </button>
    <div
      *ngIf="mainMenu$ | async as mainMenu"
      [class.hidden]="!showDropdown['teaRegions']"
      class="hidden overflow-hidden wood-background border-l-2 border-green-800">
      <a
        *ngFor = "let item of mainMenu['teaRegions']"
        [routerLink]="['/tea-region', item.slug]"
        routerLinkActive="bg-gray-700 text-white"
        ariaCurrentWhenActive="page"
        class="block px-4 py-2 text-sm text-green-800"
        (click)="closeDropdowns($event, 'teaRegions')">
        {{ item.name }}
      </a>
    </div>
  </li> -->
  <li class="w-full" (click)="showDropdown['tisaneTypes']=!showDropdown['tisaneTypes']">
    <button class="block w-full text-green-800 hover:bg-[#c4c0b0] px-3 py-2 rounded-md text-sm font-medium">
      Herbal Tea
    </button>
    @if (mainMenu$ | async; as mainMenu) {
      <div
        [class.hidden]="!showDropdown['tisaneTypes']"
        class="hidden overflow-hidden wood-background border-l-2 border-green-800">
        @for (item of mainMenu['tisaneTypes']; track item) {
          <a
            [routerLink]="['/herbal-tea', item.slug]"
            routerLinkActive="bg-gray-700 text-white"
            ariaCurrentWhenActive="page"
            class="block px-4 py-2 text-sm text-green-800"
            (click)="closeDropdowns($event, 'tisaneTypes')">
            {{ item.name }}
          </a>
        }
      </div>
    }
  </li>
  <li class="w-full" (click)="showDropdown['matchaTypes']=!showDropdown['matchaTypes']">
    <button class="block w-full text-green-800 hover:bg-[#c4c0b0] px-3 py-2 rounded-md text-sm font-medium">
      Matcha
    </button>
    @if (mainMenu$ | async; as mainMenu) {
      <div
        [class.hidden]="!showDropdown['matchaTypes']"
        class="hidden overflow-hidden wood-background border-l-2 border-green-800">
        @for (item of mainMenu['matchaTypes']; track item) {
          <a
            [routerLink]="['/matcha-tea', item.slug]"
            routerLinkActive="bg-gray-700 text-white"
            ariaCurrentWhenActive="page"
            class="block px-4 py-2 text-sm text-green-800"
            (click)="closeDropdowns($event, 'matchaTypes')">
            {{ item.name }}
          </a>
        }
      </div>
    }
  </li>
  <li class="w-full" (click)="showDropdown['teaFlavours']=!showDropdown['teaFlavours']">
    <button class="block w-full text-green-800 hover:bg-[#c4c0b0] px-3 py-2 rounded-md text-sm font-medium">
      Tea by Flavour
    </button>
    @if (mainMenu$ | async; as mainMenu) {
      <div
        [class.hidden]="!showDropdown['teaFlavours']"
        class="hidden overflow-hidden wood-background border-l-2 border-green-800">
        @for (item of mainMenu['teaFlavours']; track item) {
          <a
            [routerLink]="['/tea-flavour', item.slug]"
            routerLinkActive="bg-gray-700 text-white"
            ariaCurrentWhenActive="page"
            class="block px-4 py-2 text-sm text-green-800"
            (click)="closeDropdowns($event, 'teaFlavours')">
            {{ item.name }}
          </a>
        }
      </div>
    }
  </li>
  <li class="w-full" (click)="showDropdown['teaAccessories']=!showDropdown['teaAccessories']">
    <button class="block w-full text-green-800 hover:bg-[#c4c0b0] px-3 py-2 rounded-md text-sm font-medium">
      Teawares <!-- Renamed from "Accessories" -->
    </button>
    @if (mainMenu$ | async; as mainMenu) {
      <div
        [class.hidden]="!showDropdown['teaAccessories']"
        class="hidden overflow-hidden wood-background border-l-2 border-green-800">
        @for (item of mainMenu['teaAccessories']; track item) {
          <a
            [routerLink]="['/tea-wares', item.slug]"
            routerLinkActive="bg-gray-700 text-white"
            ariaCurrentWhenActive="page"
            class="block px-4 py-2 text-sm text-green-800"
            (click)="closeDropdowns($event, 'teaAccessories')">
            {{ item.name }}
          </a>
        }
      </div>
    }
  </li>
  <!-- <li class="w-full" (click)="showDropdown['giftTypes']=!showDropdown['giftTypes']">
  <button class="block w-full text-green-800 hover:bg-[#c4c0b0] px-3 py-2 rounded-md text-sm font-medium">
    Gifts
  </button>
  <div
    *ngIf="mainMenu$ | async as mainMenu"
    [class.hidden]="!showDropdown['giftTypes']"
    class="hidden overflow-hidden wood-background border-l-2 border-green-800">
    <a
      *ngFor = "let item of mainMenu['giftTypes']"
      [routerLink]="['/gifts', item.slug]"
      routerLinkActive="bg-gray-700 text-white"
      ariaCurrentWhenActive="page"
      class="block px-4 py-2 text-sm text-green-800"
      (click)="closeDropdowns($event, 'giftTypes')">
      {{ item.name }}
    </a>
  </div>
</li> -->
</ul>
</div>


</nav>

<div class="hidden">
  @if (mainMenu$ | async; as mainMenu) {
    <div>
      <!-- TODO : Remove this debug div -->
      Main menu loaded
      <!-- <div *ngFor = "let item of mainMenu | keyvalue">
      <p>key: {{ item.key }} </p>
      <pre>value: {{ item.value | json}} </pre>
      <pre>value: {{ item.value | json}} </pre>
    </div> -->
  </div>
}
<!-- <div *ngIf="mainMenu$ | async as mainMenu">
{{ mainMenu['giftTypes'] | json}}
</div> -->

<!-- TODO : Remove this debug div -->
<div>
  Dropdown status: {{showDropdown|json}}
</div>
</div>

<!-- TODO : Remove this div before going live -->
<div class="h-[500px] hidden">
  Remove the hidden class to add some whitespace to see the dropdowns clearer, such as viewing the shadows.
  Remove this div before going live.
</div>